var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressTo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "progress-to",
    d: "M22.7955 11.8796C22.7955 17.7639 17.9737 22.5547 12 22.5547C6.02634 22.5547 1.20452 17.7639 1.20452 11.8796C1.20452 5.99534 6.02634 1.20452 12 1.20452C17.9737 1.20452 22.7955 5.99534 22.7955 11.8796Z",
    fill: "url(#paint0_linear_1266_30078)",
    stroke: "url(#paint1_linear_1266_30078)",
    strokeWidth: 2.40905
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1266_30078",
    x1: 11.8796,
    y1: 23.7592,
    x2: 11.812,
    y2: 0.000184429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AB58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E676"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1266_30078",
    x1: 23.3543,
    y1: 23.7592,
    x2: 0.753545,
    y2: 23.8235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AB58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E676"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressTo);
export default __webpack_public_path__ + "static/media/progress-to.05a88588064998b1b4c7420b87f299e3.svg";
export { ForwardRef as ReactComponent };